<template>
    <tr>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.name"
                    placeholder="Nombre de la duración"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{row.name}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.code"
                    placeholder="Código de la duración"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{row.code}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.guide_rate"
                    placeholder="Precio guía"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{transformed_price}}
            </span>
        </td>
        <td>{{ row.id }}</td>
        <td>{{ this.$moment(row.created).format("DD/MM/YYYY HH:MM") }}</td>
        <td>{{ this.$moment(row.updated).format("DD/MM/YYYY HH:MM") }}</td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="deleteRow"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
        </td>
    </tr>
</template>


<script>
/* eslint-disable */
export default {
    componenents: {},
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            edit: false,
            form: {
                name: this.row != null ? this.row.name : '',
                code: this.row != null ? this.row.code : '',
                guide_rate: this.row != null ? this.row.guide_rate : ''
            },
        }
    },
    methods: {
        async editRow()  {
            this.edit = true
            
        },
        async saveChanges() {
            
            const data = {
                item_id: this.row.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch('activityDurationTypes/updateActivityDurationType', data)
            .then(() => {
                this.$notify({
                    group: "foo",
                    title: "Duración editada",
                    text: "Se ha editado la información del tipo de duración de actividad",
                    type: "success",
                });
                this.edit = false
            })
            .catch()
            
        },
        async deleteRow() {
            const data = {
                item_id: this.row.id,
            }
            this.$store.dispatch('activityDurationTypes/deleteActivityDurationType', data)
            .then( response => {
                this.$store.dispatch('activityDurationTypes/retrieveActivityDurationTypes')
                this.$notify({
                    group: "foo",
                    title: "La duración se ha eliminado",
                    text: "El tipo de duración de actividad " + this.row.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "La duración no se puede eliminar",
                    text: "El tipo de duración de actividad " + this.row.name + " no se puede eliminar",
                    type: "error",
                });
            })
        }
    },
    computed: {
        transformed_price() {
            if ( this.row.guide_rate.includes('.') ) {
                return this.row.guide_rate.replace('.', ',') + " €"
            }
            return this.row.guide_rate
        }
    }
}
</script>
